import { Box } from '@mui/material'
import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { Faq } from '../sections/Faq'
import { GetTouch } from '../sections/GetTouch'
import { Testimonial } from '../sections/Testimonial'

export const InformationDatabaseSecurity = () => {

    const ServiceList = [
        {
            title : 'Artificial Intelligence',
            description : 'At IMUII, we develop AI-driven systems that automate tasks, analyze data, and mimic human intelligence—empowering businesses with smarter, faster decision-making tools. '
        },
        {
            title : 'UI / UX Design',
            description : 'IMUII crafts seamless and intuitive digital experiences. Our UI/UX design ensures your users enjoy every interaction while achieving their goals efficiently and delightfully. '
        },
        {
            title : 'Web Development',
            description : 'From concept to code, IMUII builds high-performance websites with clean architecture, stunning design, and scalable functionality tailored to your business needs. '
        },
        {
            title : 'Api Integration',
            description : 'IMUII integrates APIs to connect your systems, streamline workflows, and enhance software communication—ensuring seamless data exchange and improved operational efficiency. '
        },
        {
            title : 'Mobile App Development',
            description : 'We build custom mobile apps for iOS and Android that are fast, secure, and beautifully designed—so your brand stays connected with users on the go. '
        },
        {
            title : 'Saas',
            description : 'IMUII delivers cloud-based SaaS products that are scalable, secure, and easy to maintain—helping you reduce infrastructure costs and speed up deployment. '
        },
        {
            title : 'Cloud Solutions ',
            description : 'With IMUII’s cloud services, your business can scale effortlessly. We offer secure, reliable access to computing resources, storage, and applications—anytime, anywhere. '
        },
        {
            title : 'Digital Marking',
            description : 'IMUII’s digital marketing solutions combine SEO, content, social media, and paid ads to help your brand grow, attract leads, and convert with precision online. '
        }
    ]

    // const Teamdevelopers = [
    //     {
    //         name: 'Aravind',
    //         image: '/assets/images/hire-1.png',
    //         devRole: 'Front End Developer',
    //         devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
    //         hireBtn: 'Hire Now',
    //         path: '/contact'
    //     },
    //     {
    //         name: 'Dinesh Kumar',
    //         image: '/assets/images/hire-2.png',
    //         devRole: 'Front End Developer',
    //         devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
    //         hireBtn: 'Hire Now',
    //         path: '/contact'
    //     },
    //     {
    //         name: 'Raja Laxman',
    //         image: '/assets/images/hire-3.png',
    //         devRole: 'Front End Developer',
    //         devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
    //         hireBtn: 'Hire Now',
    //         path: '/contact'
    //     },
    //     {
    //         name: 'Mani',
    //         image: '/assets/images/hire-1.png',
    //         devRole: 'Front End Developer',
    //         devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
    //         hireBtn: 'Hire Now',
    //         path: '/contact'
    //     },
    //     {
    //         name: 'Ram Charan',
    //         image: '/assets/images/hire-2.png',
    //         devRole: 'Front End Developer',
    //         devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
    //         hireBtn: 'Hire Now',
    //         path: '/contact'
    //     },
    //     {
    //         name: 'Joe Ben',
    //         image: '/assets/images/hire-3.png',
    //         devRole: 'Front End Developer',
    //         devDescription: 'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore',
    //         hireBtn: 'Hire Now',
    //         path: '/contact'
    //     },
    // ]

    const KeyFeatures = [
        {
            image : '/assets/images/info-key-1.svg',
            title : 'End-to-End Encryption ',
            description : 'We enforce strong encryption standards like AES-256 to protect data at all stages—making it unreadable to unauthorized entities. '
        },
        {
            image : '/assets/images/info-key-2.svg',
            title : 'Granular Access Management ',
            description : 'From user roles to query-level restrictions, we implement fine-tuned controls that limit exposure and enhance accountability. '
        },
        {
            image : '/assets/images/info-key-3.svg',
            title : 'Real-Time Threat Detection ',
            description : 'AI-powered monitoring alerts teams to anomalies such as SQL injections, brute force attempts, or unauthorized schema changes. '
        },
        {
            image : '/assets/images/info-key-4.svg',
            title : 'Tokenization & Data Masking ',
            description : 'We use tokenization and masking to protect PII and sensitive fields—enabling safer testing and data sharing across environments. '
        },
        {
            image : '/assets/images/info-key-5.svg',
            title : 'Multi-Factor Authentication (MFA) ',
            description : 'Secure your database logins with layered verification, reducing the risk of credential-based attacks and internal misuse. '
        },
        {
            image : '/assets/images/info-key-6.svg',
            title : 'Audit Trails & Logging ',
            description : 'Every access, change, and transaction is logged—offering full visibility and support for forensic analysis and compliance audits. '
        },
        {
            image : '/assets/images/info-key-7.svg',
            title : 'Role-Based Access Control (RBAC) ',
            description : 'Limit data access based on job roles and business requirements—streamlining permissions while maintaining strong security boundaries. '
        },
        {
            image : '/assets/images/info-key-8.svg',
            title : 'Secure Backup & Restore Framework ',
            description : 'We automate encrypted backups and ensure rapid data recovery with minimal disruption to operations or integrity loss. '
        },
        {
            image : '/assets/images/info-key-9.svg',
            title : 'Zero Trust Architecture ',
            description : 'We follow a "never trust, always verify" principle—continuously validating users and devices before granting database access. '
        },
    ]

    // const [visibleCount, setVisibleCount] = useState(6);
    // const handleExpand = () => {
    //     setVisibleCount(prevCount => Math.min(prevCount + 6, Teamdevelopers.length));
    // };
    
    //     const handleCollapse = () => {
    //     setVisibleCount(prevCount => Math.max(prevCount - 6, 6));
    // };

  return (
    <>
    
        {/* Service Detail Banner */}
        <section className='about-page'>
            <div className='about-bg'>
                <div className='c-detail-shap-1 con-shap-c'>
                    <img src="../assets/images/whi-5.svg" alt="" />
                </div>
                <div className='about-shap-3'>
                    <img src="../assets/images/about-shap-1.png" alt="" />
                </div>
                <div className='about-shap-4'>
                    <img src="../assets/images/about-shap-2.png" alt="" />
                </div>
                <div className='about-shap-5 con-shap-c'>
                    <img src="../assets/images/about-shap-3.svg" alt="" />
                </div>
                <div className='career-shap-2'>
                    <img src="../assets/images/whi-3.svg" alt="" />
                </div>
                <Container>
                    <Row className='align-items-center'>
                        <div className='col-lg-5 d-lg-block d-none position-relative' data-aos="fade-right" data-aos-duration="2000">
                            <div className='career-img text-center'>
                                <img src="../assets/images/service-7.png" alt="" />
                            </div>
                            <div className='service-shap-1'>
                                <img src="../assets/images/white-arr.svg" alt="" />
                            </div>
                        </div>
                        <div className='col-xl-6 col-lg-5 padding-0' data-aos="fade-left" data-aos-duration="2000">
                            <div className='tech-content'>
                                <h2>Information Database Security</h2>
                                <p>At IMUII, we secure your most critical asset—your data. Our database security solutions are designed to protect sensitive information against unauthorized access, breaches, and corruption while ensuring compliance with industry standards. </p>
                            </div>
                        </div>
                    </Row>
                </Container>
            </div>
        </section>

        {/* Service Detail Heading */}
        <section className='service-detail-section'>
            <Container>
                <Row className='justify-content-center'>
                    <div className="col-lg-7 col-md-10 col-sm-11">
                        <div className='service-detail-head text-center' data-aos="zoom-in" data-aos-duration="2000">
                            <h3>Advanced Information Database Security Solutions </h3>
                        </div>
                    </div>
                </Row>
                <Row>                
                    <div className="col-lg-6" data-aos="fade-right" data-aos-duration="2000">
                        <div className='service-detail-descrip text-center'>
                            <p>We implement advanced database security frameworks that protect sensitive data from breaches, misuse, and downtime. From encryption and access control to audit trails and compliance, our solutions fortify your data layer with robust defence mechanisms tailored to your business. </p>
                        </div>
                    </div>
                    <div className="col-lg-6" data-aos="fade-left" data-aos-duration="2000">
                        <div className='service-detail-descrip text-center'>
                            <p>Our services ensure continuous monitoring, secure data storage, and quick threat detection across structured and unstructured databases. Whether it's customer records, transaction logs, or proprietary information, we keep your data safe, accessible, and fully compliant with global standards. </p>
                        </div>
                    </div>
                </Row>
            </Container>
        </section>

        <section className='king-section'>
            <div className='container-fluid'>
                <div className='king-margin'>
                    <Row className='align-items-center'>
                        <div className="col-lg-7">
                            <Row>
                                <div className='col-md-6 architecture-margin' data-aos="fade-up-right" data-aos-duration="1500">
                                    <div className='architecture-text'>
                                        <h4>Data Classification & Access Control </h4>
                                        <p>We help identify and categorize sensitive data, enforcing strict role-based access controls to ensure only the right users access the right information. </p>
                                    </div>
                                </div>
                                <div className='col-md-6 architecture-margin' data-aos="fade-up-right" data-aos-duration="1700">
                                    <div className='architecture-text'>
                                        <h4>Encryption at Rest & In Transit </h4>
                                        <p>IMUII implements robust encryption protocols to protect data—both when stored in databases and during transmission across networks. </p>
                                    </div>
                                </div>
                                <div className='col-md-6 architecture-margin' data-aos="fade-up-right" data-aos-duration="1900">
                                    <div className='architecture-text'>
                                        <h4>Database Activity Monitoring (DAM) </h4>
                                        <p>We deploy real-time monitoring tools to detect unusual behaviour, unauthorized queries, and suspicious access patterns—preventing breaches before they escalate. </p>
                                    </div>
                                </div>
                                <div className='col-md-6 architecture-margin' data-aos="fade-up-right" data-aos-duration="2100">
                                    <div className='architecture-text'>
                                        <h4>Vulnerability Assessment & Patching </h4>
                                        <p>Through routine scans and updates, we identify potential weaknesses and apply critical patches to keep your database systems resilient and secure. </p>
                                    </div>
                                </div>
                            </Row>
                        </div>
                        <div className="col-lg-5 col-md-8 margin-center" data-aos="fade-up-left" data-aos-duration="2000">
                            <div className='position-relative'>
                                <div className='king-img text-center'>
                                    <img src="../assets/images/king-img.png" alt="" />
                                </div>

                                <div className='king-shap-9'>
                                    <img src="../assets/images/king-shap-9.svg" alt="" />
                                </div>                                
                                <div className='king-shap-1'>
                                    <img src="../assets/images/king-shap-1.png" alt="" />
                                </div>
                                <div className='king-shap-2'>
                                    <img src="../assets/images/king-shap-2.png" alt="" />
                                </div>
                                <div className='king-shap-3'>
                                    <img src="../assets/images/king-shap-3.svg" alt="" />
                                </div>
                                <div className='king-shap-4'>
                                    <img src="../assets/images/king-shap-4.svg" alt="" />
                                </div>
                                <div className='king-shap-5'>
                                    <img src="../assets/images/king-shap-5.svg" alt="" />
                                </div>
                                <div className='king-shap-6'>
                                    <img src="../assets/images/king-shap-6.svg" alt="" />
                                </div>
                                <div className='king-shap-7'>
                                    <img src="../assets/images/king-shap-7.svg" alt="" />
                                </div>
                                <div className='king-shap-8'>
                                    <img src="../assets/images/king-shap-8.svg" alt="" />
                                </div>
                                <div className='king-shap-10'>
                                    <img src="../assets/images/king-shap-10.svg" alt="" />
                                </div>
                                <div className='king-shap-11'>
                                    <img src="../assets/images/king-shap-11.svg" alt="" />
                                </div>
                                <div className='king-shap-12'>
                                    <img src="../assets/images/king-shap-12.svg" alt="" />
                                </div>
                            </div>
                        </div>
                    </Row>
                </div>
            </div>
        </section>

        {/* Service Detail CounterUp  */}
        <section className='counter-padding'>
                    <Container>
                        <Row className='justify-content-center'>
                            <div className="col-lg-4 col-md-6 mb-20" data-aos="fade-right" data-aos-duration="2000">
                                <div className='counter-card'>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        marginBottom: '20px'
                                    }}>
                                        <div className='counter-img'>
                                            <img src="../assets/images/service-counter.svg" alt="" />
                                        </div>
                                        <div className='counter-text'>
                                            <h3>150+</h3>
                                            <p>Projects</p>
                                        </div>
                                    </Box>
                                    <div className='counter-para'>
                                        <p>Successfully delivered over 150 projects across industries, combining innovation, precision, and performance to drive measurable results for our clients. </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-20" data-aos="zoom-in-up" data-aos-duration="2000">
                                <div className='counter-card'>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        marginBottom: '20px'
                                    }}>
                                        <div className='counter-img'>
                                            <img src="../assets/images/service-counter.svg" alt="" />
                                        </div>
                                        <div className='counter-text'>
                                            <h3>20+</h3>
                                            <p>Live Projects</p>
                                        </div>
                                    </Box>
                                    <div className='counter-para'>
                                        <p>Currently managing over 20 active projects worldwide, ensuring seamless execution, timely delivery, and continuous innovation across all technology stacks. </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-20" data-aos="fade-left" data-aos-duration="2000">
                                <div className='counter-card'>
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        marginBottom: '20px'
                                    }}>
                                        <div className='counter-img'>
                                            <img src="../assets/images/service-counter.svg" alt="" />
                                        </div>
                                        <div className='counter-text'>
                                            <h3>120+</h3>
                                            <p>Happy Clients</p>
                                        </div>
                                    </Box>
                                    <div className='counter-para'>
                                        <p>More than 120 satisfied clients trust IMUII for reliable solutions, exceptional service, and long-term partnerships built on success. </p>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </Container>
                </section>

        <section className='service-mission-section'>
            <Container>
                <Row>
                <div className="col-md-6 " data-aos="fade-right" data-aos-duration="2000">
                    <div className='mission-text'>
                    <h3>Backup Integrity & Recovery </h3>
                    <p>Our solutions include secure, automated backups with quick restore options—ensuring data availability even in the event of system failures or ransomware attacks.</p>
                    </div>
                </div> 
                <div className="col-md-6" data-aos="fade-left" data-aos-duration="2000">
                    <div className='mission-text'>
                    <h3>Compliance & Auditing </h3>
                    <p>We support adherence to global regulations like GDPR, HIPAA, and ISO by maintaining detailed logs and automating compliance reporting. </p>
                    </div>
                </div>
                <div className="col-lg-12" data-aos="zoom-in" data-aos-duration="2000">
                    <div className='mission-img'>
                    <img src="../assets/images/mission-img.jpg" alt="" />
                    </div>
                </div>
                </Row>
            </Container>
        </section>

        <section className='features-padding'>
            <Container>
                <div className='opportunities-text' data-aos="fade-right" data-aos-duration="2000">
                    <h5>Information Database </h5>
                    <h4>Security key features</h4>
                </div>

                <div className='features-margin'>
                    <Row className='justify-content-center'>
                        {
                            KeyFeatures.map((mobile,index)=>(
                                <div key={index} className="col-lg-4 col-sm-6 mb-20">
                                    <div className="features-card">
                                        <div className='features-flex'>
                                            <div className='features-img'>
                                                <img src={mobile.image} alt="" />
                                            </div>
                                            <h4>{mobile.title}</h4>
                                        </div>
                                        <div className='features-descrip'>
                                            <p>{mobile.description}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        }
                    </Row>
                </div>
            </Container>
        </section>

        {/* Faq Section */}
        <Faq />

        {/* <section className='hire-developer-section'>
            <Container>
                <div className='service-flex ser-padding'>
                    <div className='hire-developer-text' data-aos="fade-right" data-aos-duration="2000">
                        <h5>Hire A Developers</h5>
                        <h4>Hire Skilled Developers for Your Next Project </h4>
                    </div>
                    <div data-aos="fade-left" data-aos-duration="2000">
                        {visibleCount < Teamdevelopers.length && (
                            <button className="explore-btn" onClick={handleExpand}>
                                <span className="button-content">Explore More</span>
                            </button>
                        )}
                        {visibleCount > 6 && (
                            <button className="explore-btn" onClick={handleCollapse}>
                                <span className="button-content">Explore Less</span>
                            </button>
                        )}
                    </div>
                </div>

                <Row>
                    {
                        Teamdevelopers.slice(0, visibleCount).map((hireDev,index)=>(
                            <div key={index} className='col-lg-4 col-sm-6 developer-margin'>
                                <Link to={hireDev.path}>
                                    <div className="developer-card">
                                        <div className='developer-flex'>
                                            <div className='role-icon'>
                                                <img src={hireDev.image} alt="" />
                                            </div>
                                            <div className='developer-details'>
                                                <h4>{hireDev.name}</h4>
                                                <h6>{hireDev.devRole}</h6>
                                            </div>
                                        </div>
                                        <div className='dev-description'>
                                            <p>{hireDev.devDescription}</p>
                                        </div>
                                        <div className='dev-btn'>
                                            <button>{hireDev.hireBtn}</button>
                                        </div>
                                    </div>
                                </Link>
                            </div>
                        ))
                    }
                </Row>
            </Container>
        </section> */}

        {/* Get Touch Section */}
        <GetTouch />

        <section className='related-service-section'>
            <Container>
                <div className='related-service-color' data-aos="fade-right" data-aos-duration="2000">
                    <h5>Related Services</h5>
                    <h4>Explore More IT Solutions Tailored for You </h4>
                </div>

                <Row>
                    {
                        ServiceList.map((relate,index) => (
                            <div key={index} className='col-xl-3 col-lg-4 col-sm-6 mb-20'>
                                <div className='related-service-card'>
                                    <div className='related-service-text'>
                                        <h4>{relate.title}</h4>
                                        <p>{relate.description}</p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </Row>
            </Container>
        </section>

        {/* Testimonial Section */}
        <Testimonial />

    </>
  )
}
